import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-line bg-ink py-10" data-id="element-48" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-4 px-4 text-sm text-mute sm:flex-row sm:items-center" data-id="element-49" data-mp="3gfitaf6445cj">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-bone" data-id="element-50" data-mp="32lrk57wamnhc">
          Profe de Trail
        </p>
        <p data-id="element-51" data-mp="3uf0n58y9m8sr">© {new Date().getFullYear()} Pack Profe de Trail. Todos los derechos reservados.</p>
      </div>
    </footer>;
}